import React from 'react';
import { useAppState } from '../AppStateContext'; // Import useAppState

function Signup () {
    return null;
}

export default Signup;